import { ContentPostDownloadDto } from 'collaboration-service';
import { SelectFileModuleProps } from 'components/FileSelector';
import { Button, Flag, getUriFromLinkByName, Modal, Tooltip } from 'imaginarity-react-ui';
import * as _ from "lodash";
import * as React from 'react';
import { shallowCompare } from 'services/Helpers';
import { useImgI18N } from 'services/ImgI18N';
import { useSelectorGPE } from '../GeneralPostEdit';
import { GeneralPostEditState } from '../GeneralPostEditStateHandling';
import { EditorsSC as T } from './EditorsSC';

const mapper = (state: GeneralPostEditState) => ({
    post: state.post,
});

interface ContentMediaSelectorProps {
    selectProps: SelectFileModuleProps;
    lng: string;
}

const ContentMediaSelection = (p: ContentMediaSelectorProps) => {
    const { selectProps, lng } = p;
    const { post } = useSelectorGPE(mapper, shallowCompare);
    const ct = post as ContentPostDownloadDto;
    const [open, setOpen] = React.useState<boolean>(false);
    const { t } = useImgI18N("general");
    const m = t("select from other content");
    return (
        <>
            <Modal
                active={open}
                icon="copy"
                header={m}
                width="wide"
                fixed
                footer={<Button {...selectProps.buttonProps} floated='right' icon="times" content={t("cancel")} onClick={() => setOpen(false)} />}
            >
                <T.G style={{ fontWeight: "bolder", background: "rgba(0,0,0,0.05)" }}>
                    <T.D></T.D>
                    <T.L>{t("language")}</T.L>
                    <T.L>{t("content")}</T.L>
                </T.G>
                {_.map(_.filter(ct?.content, c => c.useContent === true && c.lng !== lng && !(c.content as any).copyByReference), (cc, i) => {
                    const l = cc.lng;
                    const split = l.split("-");
                    const lng = split[0].toUpperCase();
                    const co = split[1]?.toUpperCase();
                    const cl = () => {
                        setOpen(false);
                        const toSet = { ...cc.content, changed: true, copyByReference: true };
                        console.log('toSet => ', toSet);
                        selectProps.fileSelected(undefined, toSet);
                    }
                    return (
                        <T.G key={`${cc.lng}-${i}`}>
                            <Button {...selectProps.buttonProps} icon="copy" onClick={cl} />
                            <T.D>
                                {_.map(co ? [co] : [], f => <span style={{ textAlign: "left", margin: "0 10px", float: "left" }} key={f}><Flag size={18} name={f as any} /></span>)}
                                {t(lng)}
                            </T.D>
                            <T.L>
                                <a href={getUriFromLinkByName(cc.content, "self")} target="_blank" rel="noreferrer">
                                    {cc.content.fileName}
                                </a>
                            </T.L>
                        </T.G>
                    )
                })}
            </Modal>
            <Tooltip tooltipText={m} offsetX={-35} position="top" noMargin >
                <Button {...selectProps.buttonProps} icon="copy" onClick={() => setOpen(true)} />
            </Tooltip>
        </>
    );
}
export default ContentMediaSelection;